import adminApiClient from './adminApiClient';

export const adminUsersService = {
  // Company users
  getByCompany:      (companyId) => adminApiClient.get(`/api/users?companyId=${companyId}`),
  updateCompanyUser: (id, data)  => adminApiClient.put(`/api/users/${id}`, data),

  // Platform admin users
  getPlatformUsers:  ()          => adminApiClient.get('/api/admin/users'),
  createPlatformUser:(data)      => adminApiClient.post('/api/admin/users', data),
  updatePlatformUser:(id, data)  => adminApiClient.put(`/api/admin/users/${id}`, data),
  deletePlatformUser:(id)        => adminApiClient.delete(`/api/admin/users/${id}`),
};

export default adminUsersService;
